module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAKBAMAAACdwMn3AAAAElBMVEVdXV0AAABdXV1dXV1dXV1dXV17Y1VwAAAABnRSTlMxAAoeEysV1gVVAAAAH0lEQVQI12OAAAeGACgtCAYCMD5c3hgMFHDKK4GBAADKXQWLNqJ7GAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon.png
// module id = edSy
// module chunks = 1